module.exports = "/* .dwDivMask{\n    background: #ffffff;\n    z-index: 999;\n    position:fixed;\n    opacity:0.5;\n} */"